export default {
  getStaffLinkItems () {
    const items = [
      {
        name: 'Dashboard',
        icon: 'ti-home',
        path: '/staff/dashboard'
      },
      {
        name: 'Communications',
        icon: 'ti-email',
        children: [{
          name: 'Welcome Letter',
          path: '/staff/welcome'
        },
        {
          name: 'Announcements',
          path: '/staff/announcements'
        }
        ]
      },
      {
        name: 'Course',
        icon: 'nc-icon nc-pin-3',
        children: [{
          name: 'Course Details',
          path: '/staff/course'
        },
        {
          name: 'Reports',
          path: '/staff/reports'
        },
        {
          name: 'Finances',
          path: '/staff/finances'
        }
        ]
      },
      {
        name: 'Personal Info',
        icon: 'nc-icon nc-badge',
        children: [
          {
            name: 'Resource Questionnaire',
            path: '/staff/personal'
          },
          {
            name: 'Reflection Assignment',
            path: '/staff/precourse'
          },
          {
            name: 'Packing List',
            path: '/staff/packing-list'
          }
        ]
      },
      {
        name: 'Participants',
        icon: 'nc-icon nc-hat-3',
        children: [{
          name: 'Participant List',
          path: '/staff/participants'
        },
        {
          name: 'Photos',
          path: '/staff/participant-bios'
        },
        {
          name: 'Patrols',
          path: '/staff/patrols'
        },
        {
          name: 'Tickets',
          path: '/staff/ticket-goals'
        }]
      },
      {
        name: 'Staff',
        icon: 'nc-icon nc-circle-10',
        children: [{
          name: 'Staff List',
          path: '/staff/list'
        },
        {
          name: 'Staff Bios',
          path: '/staff/staff-bios'
        }
        ]
      },
      {
        name: 'Programs',
        icon: 'nc-icon nc-calendar-60',
        collapsed: true,
        children: [{
          name: 'Presentations',
          path: '/staff/presentations'
        },
        {
          name: 'Staff Dev Agendas',
          path: '/staff/staff-dev'
        },
        {
          name: 'Course Schedule',
          path: '/staff/course-schedule'
        }
        ]
      },
      {
        name: 'Help',
        icon: 'bi bi-question-circle',
        collapsed: true,
        children: [
          {
            name: 'FAQs',
            path: '/staff/faqs'
          },
          {
            name: 'Links',
            path: '/staff/links'
          },
          {
            name: 'Support',
            path: '/staff/support'
          }
        ]
      }
    ]
    return items
  },
  getParticipantLinkItems () {
    const items = [
      {
        name: 'Home',
        icon: 'ti-home',
        path: '/participant/welcome'
      },
      {
        name: 'Course Details',
        icon: 'nc-icon nc-pin-3',
        path: '/participant/course'
      },
      {
        name: 'Profile',
        icon: 'nc-icon nc-badge',
        path: '/participant/personal'
      },
      {
        name: 'Reflection Assignment',
        path: '/participant/precourse',
        icon: 'nc-icon nc-ruler-pencil'
      },
      {
        name: 'Packing List',
        path: '/participant/packing-list',
        icon: 'nc-icon nc-tag-content'
      },
      {
        name: 'Ticket',
        icon: 'nc-icon nc-air-baloon',
        path: '/participant/ticket'
      },
      {
        name: 'Staff Bios',
        icon: 'nc-icon nc-circle-10',
        path: '/participant/staff-bios'
      },
      {
        name: 'FAQs',
        icon: 'bi bi-chat-left-text',
        path: '/participant/faqs'
      },
      {
        name: 'Links',
        icon: 'bi bi-link-45deg',
        path: '/participant/links'
      },
      {
        name: 'Support',
        icon: 'bi bi-question-circle',
        path: '/participant/support'
      }]

    return items
  }
}
